import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { queryKeys } from '../constants';
import { CreateWidgetModel } from '../models';

export function useCreateWidget() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateWidgetModel) => {
      const { data } = await $api.post('/v1/dashboard/widget', payload);

      return data;
    },
    onSuccess: async (res, payload) => {
      showMessage(res.message, true);

      await qc.invalidateQueries([queryKeys.DASHBOARD_WIDGETS, Number(payload?.dashboardId)]);
    },
    onError: baseErrorHandler
  });
}
